// Modo de margen por bot (bot_configs.margin_mode: 'isolated' | 'cross' |
// NULL = aislado) -- WP-exchange-modos / WP-wizard-exchange-modos. Un único
// mapeo bot -> formulario -> payload compartido por los formularios de bot:
// PUT /bots/{id} REEMPLAZA margin_mode por lo que llegue (bot_service.
// update_bot), así que un formulario que no lo transporte lo resetearía a
// aislado en silencio al editar un bot cruzado.
export function marginModeFromBot(bot) {
  return bot?.margin_mode === 'cross' ? 'cross' : 'isolated'
}

export function marginModeToPayload(value) {
  return value === 'cross' ? 'cross' : 'isolated'
}
